import React from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { AuthRoute } from '../components/auth/authRoute';
import { useAuth } from '../providers/auth.provider';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

const RootComponent = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return (
      <>
        <AuthRoute>
          <>
            <Outlet />
            <TanStackRouterDevtools />
          </>
        </AuthRoute>
      </>
    );
  } else {
    return (
      <>
        <Outlet />
        <TanStackRouterDevtools />
      </>
    );
  }
};

export const Route = createRootRoute({
  component: RootComponent,
});
